import { useRoute } from 'expo-router/react-navigation';

/**
 * Reads a search param from the raw route params, decoded once. `useLocalSearchParams` decodes
 * query values a second time, which corrupts a param that carries an encoded URL (an encoded
 * `&`, `=`, `#` or `?` inside it turns into a separator).
 * @param name - The search param to read; the first value wins when it is repeated.
 */
export function useRawSearchParam(name: string): string | undefined {
  const params = useRoute().params as Record<string, string | string[] | undefined> | undefined;
  const value = params?.[name];
  return Array.isArray(value) ? value[0] : value;
}
